<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <fieldset legend="RESIDENTS.GENERAL_INFO">
    <div class="row">
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="code"
          inputValidator
          readonly
          label="RESIDENTS.CODE"
        />
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="firstName"
          inputValidator
          label="RESIDENTS.FIRST_NAME"
          type="text"
        />
      </div>
      <div class="col-lg-6">
        <p-calendar
          formControlName="birthDate"
          inputValidator
          label="RESIDENTS.BIRTH_DATE"
          inputStyleClass="form-control"
        ></p-calendar>
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="lastName"
          inputValidator
          label="RESIDENTS.LAST_NAME"
          type="text"
        />
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="idCardNumber"
          inputValidator
          label="RESIDENTS.ID_CARD_NUMBER"
          type="text"
        />
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="middleName"
          inputValidator
          label="RESIDENTS.MIDDLE_NAME"
          type="text"
        />
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="socialStatus"
          inputValidator
          label="RESIDENTS.SOCIAL_STATUS"
          type="text"
        />
      </div>
      <div class="col-lg-6">
        <input
          class="form-control"
          formControlName="phoneNumber"
          inputValidator
          label="RESIDENTS.PHONE_NUMBER"
          type="text"
        />
      </div>
      <div class="col-lg-12">
        <input
          class="form-control"
          formControlName="email"
          inputValidator
          label="RESIDENTS.EMAIL"
          type="email"
        />
      </div>
    </div>
  </fieldset>

  <fieldset legend="RESIDENTS.BANK_INFO">
    <div class="row">
      <div class="col-lg-4">
        <input
          class="form-control"
          formControlName="bankCode"
          inputValidator
          label="RESIDENTS.BANK_CODE"
          type="text"
        />
      </div>
      <div class="col-lg-4">
        <input
          class="form-control"
          formControlName="bankAccount"
          inputValidator
          label="RESIDENTS.BANK_ACCOUNT"
          type="text"
        />
      </div>
      <div class="col-lg-4">
        <input
          class="form-control"
          formControlName="taxCode"
          inputValidator
          label="RESIDENTS.TAX_CODE"
          type="text"
        />
      </div>
    </div>
  </fieldset>

  <fieldset legend="RESIDENTS.APARTMENT_INFO">
    <div class="row">
      <div class="col-lg-12">
        <ng-select
          [clearable]="false"
          [items]="rentTypes"
          bindLabel="name"
          bindValue="id"
          formControlName="rentType"
          inputValidator
          label="RESIDENTS.RENT_TYPE"
        />
      </div>
      <div class="col-lg-6">
        <div class="form-check form-switch mt-2">
          <input class="form-check-input" formControlName="status" role="switch" type="checkbox">
          <label class="form-check-label">{{ 'RESIDENTS.STATUS' | translate }}</label>
        </div>
      </div>
    </div>
  </fieldset>

  <div class="text-end d-flex justify-content-end gap-2 mt-3">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
